<template>
  <div class="content">
    <el-form :model="queryParams"  ref="queryParams"  :inline="true">
        <el-form-item prop="userId">
            <el-cascader
            placeholder="公司名"
            ref="myCascader"
            :options="agentList"
            :props="{ value : 'userId' ,checkStrictly: true,emitPath:false }"
            :show-all-levels="false"
            clearable
            v-model="queryParams.userId"
            @change="search"
            filterable
          >
            <template slot-scope="{ node, data }">
              <span>[{{ data.username }}]{{ data.label }}</span>
              <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
            </template>
          </el-cascader>
        </el-form-item>
        <el-form-item prop="realName">
          <el-input v-model="queryParams.realName" placeholder="身份证姓名" @keyup.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item prop="companyName">
          <el-input v-model="queryParams.realName" placeholder="企业名称" @keyup.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item prop="status">
          <el-select v-model="queryParams.status" filterable placeholder="认证状态" @change="search">
            <el-option
              v-for="item in options"
              :key="item.cardStatus"
              :label="item.operationName"
              :value="item.cardStatus"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            <el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>  
        </el-form-item>
    </el-form>
    <el-table :data="tableData" border>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="agentCompanyName" label="公司名称" min-width="260px" :show-overflow-tooltip="true" align="center"></el-table-column>
      <el-table-column prop="realName" label="身份证姓名" min-width="100px" align="center"></el-table-column>
      <el-table-column prop="phone" label="实名手机号" min-width="130px" :show-overflow-tooltip="true" align="center"></el-table-column>
      <el-table-column prop="company" label="企业名称" :show-overflow-tooltip="true" align="center"></el-table-column>
      <el-table-column prop="kycType" label="认证类型" align="center">
        <template slot-scope="{row}">
          <span v-if="row.kycType == '1'">个人认证</span>
          <span v-else>企业认证</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" width="200px"></el-table-column>
      <el-table-column prop="auditTime" label="审核时间" align="center" width="200px"></el-table-column>
      <el-table-column prop="remark" label="备注" align="center" ></el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="{row}">
          <el-tag v-if="row.status == '1'" type="success">待审核</el-tag>
          <el-tag v-else-if="row.status =='2'">已审核</el-tag>
          <el-tag v-else type="danger">未通过</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary"  plain icon="el-icon-view" @click="editRow(scope.row.id)" v-hasPermi="['company:authentication:detail']" >详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import { agentTreeList } from "@/api/api.js"; //代理商
import { kycList } from "@/api/api.js"; //实名列表
export default {
  data() {
    return {
      //代理商层级
      agentList:[],
      queryParams:{
        userId:undefined,
        realName:undefined,
        companyName:undefined,
        status:undefined
      },
      page: 1,
      pageSize: 20,
      total: 0,
      // 排序方式
      sortOrder: "",
      // 排序名称
      sortName: "",
      options: [
        {
          cardStatus: "0",
          operationName: "待审核"
        },
        {
          cardStatus: "1",
          operationName: "已审核"
        },
        {
          cardStatus: "2",
          operationName: "未通过 "
        },
      ],
      tableData: [],
    };
  },
  computed: {},
  methods: {
    // 获取初始化代理商列表
    agentTreeListMethod(){
      agentTreeList().then(res => {
        this.agentList = res.data.data;
      });
    },
    // 获取列表
    initData() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      kycList(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    reset() {
      this.resetForm("queryParams");
      this.search();
    },
    // 详情
    editRow(id) {
      this.$router.push(`/authentication/detail/`+id);
    },
  },
  created() {
    this.initData();
    this.agentTreeListMethod();
  },
  mounted() {
    
  }
};
</script>
<style scoped lang="less">

</style>


